export default __webpack_public_path__ + "static/media/slider_image_03-lg@1x.fa1d9522.jpg";